/* Keep the product-page search/navigation visible, without cloning controls. */
(function(){
 function init(){
  if(!document.body.classList.contains('template-product'))return;
  var root=document.getElementById('shopify-section-header');if(!root||root.dataset.ammStickyReady)return;
  root.dataset.ammStickyReady='1';
  var spacer=document.createElement('div');spacer.hidden=true;spacer.setAttribute('aria-hidden','true');root.after(spacer);
  var topbar=root.querySelector('.deodap-topbar'),desktop=window.matchMedia('(min-width:990px)'),height=0,bar=0;
  function measure(){height=root.getBoundingClientRect().height;bar=topbar?topbar.getBoundingClientRect().height:0;root.style.setProperty('--amm-announcement-height',bar+'px');document.documentElement.style.setProperty('--amm-sticky-header-height',Math.max(0,height-bar)+'px');spacer.style.height=height+'px';update();}
  function update(){var on=desktop.matches&&window.scrollY>bar;root.classList.toggle('amm-header-fixed',on);spacer.hidden=!on;}
  window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',measure,{passive:true});
  if(window.ResizeObserver)new ResizeObserver(measure).observe(root);measure();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
